import { DateTime } from 'luxon';
import { ConnnatixLiveStreamSchedule } from './entities';
import { LivestreamManager } from './manager';
import { Session } from '@benzinga/session';

export const parseScheduleTime = (time: string) => {
  const TIME_PARSE_FORM = 'h:mm a';

  return DateTime.fromFormat(time, TIME_PARSE_FORM, { setZone: true, zone: 'America/New_York' });
};

export const isLivestreamInSchedule = (schedules: ConnnatixLiveStreamSchedule[]) => {
  if (Array.isArray(schedules)) {
    return schedules.some(schedule => {
      const startAt = parseScheduleTime(schedule.start_at);
      const endAt = parseScheduleTime(schedule.end_at);

      const currentTime = DateTime.now().setZone('America/New_York');
      const currentDay = currentTime.toFormat('EEE').toLowerCase();

      if (schedule.day === currentDay) {
        const diffOne = startAt.diff(currentTime).as('hours');
        const diffTwo = endAt.diff(currentTime).as('hours');

        if (diffOne <= 0 && diffTwo >= 0) {
          return true;
        }
      }

      return false;
    });
  }

  return false;
};

export const getInitialLiveStream = (session: Session) => {
  if (!session) return undefined;
  try {
    const livestreamManager = session.getManager(LivestreamManager);
    const storedLivestream = livestreamManager.getStoredConnatixLivestream();

    if (storedLivestream?.enabled && storedLivestream?.data?.schedule) {
      if (isLivestreamInSchedule(storedLivestream?.data?.schedule)) {
        return storedLivestream.data;
      }
    }

    return undefined;
  } catch {
    return undefined;
  }
};
